import { createReducer } from '@reduxjs/toolkit';
import {
    SET_MUSIC_DATA,
    RESET_SINGLE_MUSIC,
    SET_IS_LOADING,
    SET_SINGLE_MUSIC,
    SET_NOT_FOUND,
    SET_IS_RELATED_NEWS,
    SET_NEWS_SINGLE_MUSIC,
    SET_PENDING_SLUG,
} from '../actions/MusicSingleActions';

const initialState = {
    singleMusicData: {},
    news: [],
    musicsPageData: [],
    isLoading: true,
    notFound: false,
    isRelatedNews: false,
    pendingSlug: null,
};

// @TODO create an ADD_MUSIC as this and SET are two different things.
// The SET_MUSIC can be a reset too when applying filters.
// currently we (re)set the playlist on every play click on any music item

const musicSingle = createReducer(initialState, (builder) => {
    builder
        .addCase(SET_MUSIC_DATA, (state, action) => {
            state.musicsPageData = action.data;
        })
        .addCase(SET_IS_LOADING, (state, action) => {
            state.isLoading = action.isLoading;
        })
        .addCase(SET_SINGLE_MUSIC, (state, action) => {
            state.singleMusicData = action.data;
        })
        .addCase(RESET_SINGLE_MUSIC, (state) => {
            state.singleMusicData = {};
        })
        .addCase(SET_PENDING_SLUG, (state, action) => {
            state.pendingSlug = action.pendingSlug;
        })
        .addCase(SET_NOT_FOUND, (state, action) => {
            state.notFound = action.notFound;
        })
        .addCase(SET_NEWS_SINGLE_MUSIC, (state, action) => {
            state.news = action.news;
        })
        .addCase(SET_IS_RELATED_NEWS, (state, action) => {
            state.isRelatedNews = action.isRelatedNews;
        });
});

export default musicSingle;
